import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { UtilsService } from 'src/app/services/utils.service';
import { CdkDrag } from '@angular/cdk/drag-drop';
import { NgIf } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';


@Component({
    selector: 'app-show-message',
    templateUrl: './show-message.component.html',
    styleUrls: ['./show-message.component.css'],
    imports: [CdkDrag, NgIf, LucideAngularModule]
})
export class ShowMessageComponent implements OnInit {

  
  @Input() message: any;
  @Input() action:any
  @Input() showNotifyButton: boolean = true

  @Output() closeMessageEvent = new EventEmitter();
  @Output() cancelMessageEvent = new EventEmitter();
  @Output() deleteMessageEvent = new EventEmitter();
  @Output() confirmMessageEvent = new EventEmitter();

  title: string=''

  constructor(private utilsService:UtilsService)  {}


  ngOnInit(): void {

    switch (this.action){
      case 'delete':
        this.title='Eliminar evento'
        break;
      case 'serie':
        this.title='Evento serie'
        break;
      case 'done':
        this.title='Confirmación'
        break;
      case 'alert':
        this.title='Alerta'
        break;
      case 'info':
          this.title='Aviso'
          break;
      default:
        this.title='Notificación'
        break;
    }
     
      

      

   /* if (this.action=='delete')
    this.title='Eliminar evento'
    else this.title='Evento serie'*/
   
  }


  deleteEvent(event){
    this.deleteMessageEvent.emit({ result: "eliminar", notify: false})                                      
  }

  closeEvent(event){
    this.closeMessageEvent.emit()
  }

  cancelEvent(event){
    this.cancelMessageEvent.emit({result: 'cancelar'})
  }

  confirmEvent(event){
    this.confirmMessageEvent.emit({result:'update'})

  }

  deleteEventWithNotify(event, notify: boolean){
    this.deleteMessageEvent.emit({ result: 'eliminar', notify: !!notify });
  }

 

 
}












